import React from 'react';

import ErrorDisplay from './ErrorDisplay';

const SyncHealthNotification = ({ syncErrors = [] }) => {
  const errors = syncErrors.map((error, index) => (
    <div key={`${error.source}_sync_errors-${index}`}>
      <p className="source">Source {error.source} reported: </p>
      <ErrorDisplay
        error={error?.syncErrors?.error}
        action="synchronizing"
      />
      <ErrorDisplay
        error={error?.backfillErrors?.error}
        action="backfilling"
      />
    </div>
  ));

  return (
    <div className="sync-health-component">
      <div className="sync-health-component--text">
        The information presented in this panel might not be complete.
      </div>
      {errors}
      <div className="sync-health-component--text">
        Don't worry. These errors typically resolve themselves.
      </div>
      <div className="sync-health-component--text">
        If the issue persists for a longer period please contact support.
      </div>
    </div>
  );
};
export default SyncHealthNotification;
